/* English dictionary: dev namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const dev = {
  'dev.render.title': [ 'Ivory Roulette' ],
  'dev.render.subtitle': [ 'Backend debug terminal' ],
  'dev.render.phase': [ 'Phase' ],
  'dev.render.drawPile': [ 'Draw pile' ],
  'dev.render.discardPile': [ 'Discard pile' ],
  'dev.render.out': [ '(out)' ],
  'dev.render.disconnected': [ 'Disconnected' ],
  'dev.render.seats': [ 'Seats' ],
  'dev.render.host': [ '   (you are host)' ],
  'dev.render.attacked': [ ' · attacked' ],
  'dev.render.turn': [ 'Turn' ],
  'dev.render.turnTo': [ { type: 'param', name: 'who' }, '\'s turn' ],
  'dev.render.actionsLeft': [ '(', { type: 'param', name: 'n' }, ' actions left)' ],
  'dev.render.viewpoint': [ 'Viewpoint' ],
  'dev.render.eliminated': [ '(out)' ],
  'dev.render.emptyHand': [ 'Hand empty' ],
  'dev.render.othersHands': [ 'Other hands: ' ],
  'dev.render.knownTop': [ 'Known top of deck: ' ],
  'dev.render.responseWindow': [ '▶ Response window' ],
  'dev.render.playedBy': [ { type: 'param', name: 'actor' }, ' played' ],
  'dev.render.nopeChain': [ 'Nope chain ', { type: 'param', name: 'n' }, ' cards → effect ' ],
  'dev.render.willCancel': [ 'will be cancelled' ],
  'dev.render.willApply': [ 'will resolve' ],
  'dev.render.eligible': [ 'Eligible to nope: ' ],
  'dev.render.none': [ '(none)' ],
  'dev.render.drewRescue': [ 'Drew ', { type: 'param', name: 'card' }, '; use a rescue card?' ],
  'dev.render.insertWhere': [ 'Where to insert ', { type: 'param', name: 'card' }, ' back into the deck?' ],
  'dev.render.giveOne': [ 'Choose a card to give' ],
  'dev.render.giveNamed': [ 'Give a "', { type: 'param', name: 'title' }, '"' ],
  'dev.render.stealOne': [ 'Pick one from their hand (', { type: 'param', name: 'n' }, ' card backs)' ],
  'dev.render.pickDiscard': [ 'Pick one from the discard pile' ],
  'dev.render.pending': [ '▶ Decision' ],
  'dev.render.gameOver': [ 'Game over' ],
  'dev.render.noWinner': [ 'No winner (draw)' ],
  'dev.render.wins': [ { type: 'param', name: 'name' }, ' wins' ],
  'dev.render.event.played': [ 'Played ', { type: 'param', name: 'n' }, ' cards (', { type: 'param', name: 'kind' }, ')' ],
  'dev.render.event.drawn': [ { type: 'param', name: 'player' }, ' drew a card', { type: 'param', name: 'secret' } ],
  'dev.render.event.secret': [ ' (secret)' ],
  'dev.render.event.stolen': [ { type: 'param', name: 'by' }, ' stole one from ', { type: 'param', name: 'from' } ],
  'dev.render.event.given': [ { type: 'param', name: 'by' }, ' gave one to ', { type: 'param', name: 'to' } ],
  'dev.render.event.reclaimed': [ { type: 'param', name: 'by' }, ' reclaimed one from the discard pile' ],
  'dev.render.event.windowOpened': [ 'Response window opened' ],
  'dev.render.event.noped': [ { type: 'param', name: 'player' }, ' played Nope' ],
  'dev.render.event.windowCancelled': [ 'Window closed (effect cancelled)' ],
  'dev.render.event.windowApplied': [ 'Window closed (effect resolves)' ],
  'dev.render.event.lethalDrawn': [ { type: 'param', name: 'player' }, ' drew a lethal card!' ],
  'dev.render.event.lethalDefused': [ { type: 'param', name: 'player' }, ' defused it' ],
  'dev.render.event.lethalExploded': [ { type: 'param', name: 'player' }, ' exploded and is out' ],
  'dev.render.event.shuffled': [ 'Deck shuffled' ],
  'dev.render.event.peeked': [ { type: 'param', name: 'player' }, ' secretly peeked at the top of the deck' ],
  'dev.render.event.attacked': [ { type: 'param', name: 'player' }, ' was attacked, owes ', { type: 'param', name: 'n' }, ' turns' ],
  'dev.render.event.turnStarted': [ 'Turn: ', { type: 'param', name: 'player' } ],
  'dev.render.event.turnEnded': [ { type: 'param', name: 'player' }, '\'s turn ended' ],
  'dev.render.event.won': [ { type: 'param', name: 'player' }, ' wins' ],
  'dev.sim.duplicate': [ 'The same card instance appears in multiple places' ],
  'dev.sim.leaked': [ { type: 'param', name: 'missing' }, ' cards are nowhere (card table ', { type: 'param', name: 'total' }, ', on field ', { type: 'param', name: 'seen' }, ')' ],
  'dev.sim.noSuchPlayer': [ 'Turn points to a nonexistent player ', { type: 'param', name: 'id' } ],
  'dev.sim.deadHolder': [ 'Turn is stuck on eliminated ', { type: 'param', name: 'name' } ],
  'dev.sim.discardShrank': [ 'Discard pile shrank from ', { type: 'param', name: 'from' }, ' to ', { type: 'param', name: 'to' }, ', but nobody reclaimed' ],
  'dev.sim.noActor': [ 'Game is still running but no one can act' ],
  'dev.sim.pendingDecision': [ ' (decision: ', { type: 'param', name: 'kind' }, ')' ],
  'dev.sim.responseWindowOpen': [ ' (response window open)' ],
  'dev.sim.noLegalAction': [ 'Turn: ', { type: 'param', name: 'actor' }, ' ', { type: 'param', name: 'pending' }, { type: 'param', name: 'window' }, ', but has no legal action' ],
  'dev.sim.noWinner': [ 'Game ended with no winner (', { type: 'param', name: 'alive' }, ' alive, ', { type: 'param', name: 'draw' }, ' in draw pile)' ],
  'dev.sim.reachedEnd': [ 'reached the end' ],
  'dev.sim.noActorShort': [ 'no one can act' ],
  'dev.sim.botStuck': [ 'bot has no move' ],
  'dev.sim.rejected': [ 'Step ', { type: 'param', name: 'step' }, ': the bot action was rejected: ', { type: 'param', name: 'reason' } ],
  'dev.sim.noProgress': [ 'Step ', { type: 'param', name: 'step' }, ': action ', { type: 'param', name: 'action' }, ' did not advance the state' ],
  'dev.sim.wedged': [ { type: 'param', name: 'reason' }, '; ran ', { type: 'param', name: 'steps' }, ' steps without finishing (', { type: 'param', name: 'draw' }, ' in draw pile, ', { type: 'param', name: 'alive' }, ' alive)' ],
  'dev.sim.setupFailed': [ 'Failed to set up the game: ', { type: 'param', name: 'reason' } ],
  'dev.sim.violation': [ '[', { type: 'param', name: 'code' }, '] seed ', { type: 'param', name: 'seed' }, ' (', { type: 'param', name: 'players' }, ' players / ', { type: 'param', name: 'profile' }, '): ', { type: 'param', name: 'message' } ],
  'dev.sim.ranRounds': [ ' Ran ', { type: 'param', name: 'n' }, ' random games (', { type: 'param', name: 'profiles' }, ' bot profiles rotating)' ],
  'dev.sim.avgSteps': [ ' Average ', { type: 'param', name: 'n' }, ' steps per game' ],
  'dev.sim.endings': [ ' Endings' ],
  'dev.sim.winnerCount': [ 'Winner ', { type: 'param', name: 'n' } ],
  'dev.sim.noWinnerCount': [ 'No winner ', { type: 'param', name: 'n' } ],
  'dev.sim.wedgedCount': [ 'Wedged ', { type: 'param', name: 'n' } ],
  'dev.sim.profileLine': [ { type: 'param', name: 'total' }, ' games, ', { type: 'param', name: 'winner' }, ' with winner (', { type: 'param', name: 'rate' }, '%)' ],
  'dev.sim.hitRates': [ ' Rule-area hit rates (average per game)' ],
  'dev.sim.playKinds': [ 'Play kinds  single ', { type: 'param', name: 'single' }, '  pair ', { type: 'term', term: 'pair' }, '  triple ', { type: 'term', term: 'triple' }, '  five ', { type: 'term', term: 'fiveDifferent' } ],
  'dev.sim.lethal': [ 'Lethal resolution  drawn ', { type: 'param', name: 'drawn' }, '  defused ', { type: 'param', name: 'defused' }, '  exploded ', { type: 'param', name: 'exploded' } ],
  'dev.sim.decisions': [ 'Decisions' ],
  'dev.sim.insertAt': [ 'Insert position' ],
  'dev.sim.window': [ 'Window  applied ', { type: 'param', name: 'applied' }, '  cancelled ', { type: 'param', name: 'cancelled' }, '  max nope chain ', { type: 'param', name: 'maxChain' } ],
  'dev.sim.other': [ 'Other  emptied while alive ', { type: 'param', name: 'emptied' }, '  dead players noped ', { type: 'param', name: 'deadNoped' }, '  attack turn counts' ],
  'dev.sim.allGood': [ ' ✅ No fatal issues: no deadlocks, no lost or duplicate cards, turns never stop on an eliminated player' ],
  'dev.sim.fatalFound': [ ' ❌ Found ', { type: 'param', name: 'n' }, ' fatal issues:' ],
  'dev.sim.softFound': [ ' ⚠️ ', { type: 'param', name: 'n' }, ' soft issues (allowed by the rules but worth a look):' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
dev satisfies Record<string, TextSpec>;
export default dev;
